export class documentCard {
  [x: string]: any;

  id: string = null;
  author: string = null;
  title: string = null;
  content: string = null;
  keyword: string = null;
  type: string = null;
  group: Array<string> = new Array<string>();
  tags: Array<string> = new Array<string>();
  isGroup = false;
  addedAt: any = null;
  modifiedAt: any = null;
  url: string = null;
  isAdded = false;
  style = null;
  totalDocuments: number = null;
  isBookmarked = false;
  images: Array<string> = new Array<string>();
  favicon: any;
  isPinned: boolean = null;
  isSelected: boolean = null;
  imageURLMapArr: any;
  imageURLMap: any;
  isDraft: boolean = null;
  documentIdList: Array<string> = new Array<string>();
  channel?: string = null;
  create_date?: string = null;
  mediaType?: string[];
  searchType?: string;
  description?: string;
  docId?: any;
  image_uri?: string[];
  image_uri_thumbnail?: string;
  path?: string;
  service_html?: string;
  published_at?: string;
  forcedClustering?: boolean;
  targetBpId?: string;
  lang?: string;
  originDate?: string;
  parentDocId?: string;
  docType?: any;
  isInsideGroup?: boolean;
  userKey?: string;
  writer?: string[];
  owner_user_key?: string;

  constructor(docDetail?) {
    this.content = '';
    this.title = '';
    this.docDetail = docDetail;
  }
}
